import { priceSimulatorStrings } from '@data/priceSimulator';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: priceSimulatorStrings.priceSimulator,
  },
});

export const meta: PageMeta = {
  title: strings.title,
};
